import { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { FilterType } from '@/types/logs'
import styles from './TabFilters.module.scss'
import { useCombinedLogsTableStateStore } from '../../store'

export const TabFilters = () => {
    const { filter, setFilter } = useCombinedLogsTableStateStore()
    const [active, setActive] = useState<FilterType>(filter.type)
    const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 })

    const dailyRef = useRef<HTMLButtonElement>(null)
    const mileageRef = useRef<HTMLButtonElement>(null)
    const allRef = useRef<HTMLButtonElement>(null)

    const handleSetActive = (type: FilterType) => {
        setActive(type)
        setFilter(type)
    }

    useEffect(() => {
        let ref: React.RefObject<HTMLButtonElement>
        switch (active) {
            case FilterType.DailyLog:
                ref = dailyRef
                break
            case FilterType.MileageLoss:
                ref = mileageRef
                break
            case FilterType.All:
                ref = allRef
                break
        }

        if (ref.current) {
            const { offsetLeft, offsetWidth } = ref.current
            setHighlightStyle({ left: offsetLeft, width: offsetWidth })
        }
    }, [active])

    useEffect(() => {
        setActive(filter.type)
    }, [filter.type])

    return (
        <div className={styles.tabsContainer}>
            <button
                ref={dailyRef}
                onClick={() => handleSetActive(FilterType.DailyLog)}
                className={clsx(styles.tab, { [styles.tabActive]: active === FilterType.DailyLog })}
            >
                Daily log
            </button>
            <button
                ref={mileageRef}
                onClick={() => handleSetActive(FilterType.MileageLoss)}
                className={clsx(styles.tab, { [styles.tabActive]: active === FilterType.MileageLoss })}
            >
                Mileage losses
            </button>
            <button
                ref={allRef}
                onClick={() => handleSetActive(FilterType.All)}
                className={clsx(styles.tab, { [styles.tabActive]: active === FilterType.All })}
            >
                All records
            </button>
            <div
                className={styles.tabHighlight}
                style={{
                    left: highlightStyle.left,
                    width: highlightStyle.width,
                }}
            />
        </div>
    )
}
